module.exports = __webpack_public_path__ + "img/core-advantages-6.be5fb006.svg";